import { css } from '@emotion/react';

export default (width?: string | number) =>
  css({
    '&+:has(.tippy-box)': {
      width,
    },
  });
